import React from 'react';
import PropTypes from 'prop-types';
import {makeStyles, styled} from "@material-ui/core";
import Typography from "@material-ui/core/Typography";
import Link from "@material-ui/core/Link";

const useStyles = makeStyles(theme => ({
    link: {
        fontFamily: "Metropolis",
        fontStyle: "normal",
        fontWeight: "600",
        fontSize: "16px",
        lineHeight: "16px",
        cursor: "pointer",
        color: "var(--color-blue-600)",
    },
}));

function LinkTableCellComponent({name, onLinkClick, href}) {
    const classes = useStyles();

    return (
        <span>
            <Link href={href} onClick={onLinkClick} className={classes.link}>
                {name}
            </Link>
        </span>
    );
}

LinkTableCellComponent.propTypes = {};
LinkTableCellComponent.defaultProps = {};

export default LinkTableCellComponent;
